import apiFetch from '../apiFetch'

export default function (token, metadatoList) {
  return apiFetch({ endPoint: 'MetadataList', method: 'POST', body: metadatoList, token: token })
}
